// GENERATED FILE — do not edit by hand.
// Overwritten at build time by scripts/generate-version.js.
export const APP_VERSION = '518baea55309a8ad9b3f603a680fc25f4f77cea4';
export const BUILD_NUMBER = '202';
export const BUILD_TIMESTAMP = '2026-07-22T13:01:08.607Z';
